export const paths = {
    home: '/',
    quiz: '/quiz',
    suggestions: '/suggestions',
    email: '/email',
    result: '/result',
    paywall: '/offer',
};
